import { useDispatch } from 'react-redux';

import { DatePicker } from '@raystack/apsara';

import { setEndDate, setStartDate } from '@src/redux/_reducers/filtersReducer';
import { EXPLORE_FILTER_START_YEAR } from '@src/utils/constants/APP';

type Filters = {
  startDate?: Date;
  endDate?: Date;
};

export function DateRangePicker({ filters }: { filters: Filters }) {
  const dispatch = useDispatch();

  const today = new Date();
  const { startDate, endDate } = filters;

  const handleStartSelect = (date: Date) => {
    if (!date) return;

    const start = date;
    let newEndDate = endDate;

    if (newEndDate && start.getTime() > newEndDate.getTime()) {
      newEndDate = new Date(
        Math.min(
          newEndDate.getTime() + 15 * 24 * 60 * 60 * 1000,
          today.getTime()
        )
      );
    }

    dispatch(setStartDate(start));
    dispatch(setEndDate(newEndDate));
  };

  const handleEndSelect = (date: Date) => {
    if (!date) return;
    dispatch(setEndDate(date));
  };

  return (
    <div style={{ display: 'flex', gap: '1rem' }}>
      <DatePicker
        popoverProps={{
          side: 'bottom'
        }}
        dateFormat='D MMM YYYY'
        value={startDate}
        onSelect={handleStartSelect}
        calendarProps={{
          captionLayout: 'dropdown',
          startMonth: EXPLORE_FILTER_START_YEAR,
          endMonth: today,
          mode: 'single',
          required: true,
          selected: startDate,
          disabled: (day: Date) => day > today
        }}
        inputFieldProps={{
          placeholder: 'Select start date',
          size: 'large',
          readOnly: true
        }}
      />

      <DatePicker
        key={endDate ? endDate.toISOString() : 'no-end-date'}
        popoverProps={{
          side: 'bottom'
        }}
        dateFormat='D MMM YYYY'
        value={endDate}
        onSelect={handleEndSelect}
        calendarProps={{
          captionLayout: 'dropdown',
          startMonth: startDate || EXPLORE_FILTER_START_YEAR,
          endMonth: today,
          mode: 'single',
          required: true,
          selected: endDate,
          disabled: (day: Date) => {
            if (startDate) return day < startDate || day > today;
            return day > today;
          }
        }}
        inputFieldProps={{
          placeholder: 'Select end date',
          size: 'large',
          readOnly: true
        }}
      />
    </div>
  );
}
